import Modal from 'components/desktop/shared/modal';
import { Map as MapModel } from 'graphql/main/queries';
import dynamic from 'next/dynamic';

const Map = dynamic(() => import('components/shared/map'), { ssr: false });

interface Props {
  map?: MapModel;
  onClose?: () => void;
}

const MapModal = ({ map, onClose }: Props) => (
  <Modal
    closable
    title='Xem bản đồ'
    className='fixed top-[24px] left-[24px] right-[24px] bottom-[24px]'
    onClose={onClose}
  >
    <div className='h-full overflow-hidden rounded-[16px]'>
      <Map map={map} />
    </div>
  </Modal>
);

export default MapModal;
